import React, { Component, useState, useMemo } from "react";
import DefaultDataGrid from '../components/DefaultDataGrid';
import { DataGrid, GridToolbar, plPL, getGridStringOperators, GridActionsCellItem } from '@mui/x-data-grid';
import { useParams } from 'react-router';
import { TextField, Typography, Slide, Button, Box, CircularProgress, Checkbox } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Stack } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import { query, flattenObj, unflattenObject } from '../App';
import InputColumn from '../components/InputColumn'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Link } from "react-router-dom"
import DefaultSite from '../components/DefaultSite';
import RowAddPage from '../components/RowAddPage';
import RowEditPage from '../components/RowEditPage';
import AutocompleteText from '../components/AutocompleteText';
import AddIcon from '@mui/icons-material/Add';
import InputRow from "../components/InputRow";
import { OrdersDataGrid, productCellRenderer } from "./Orders";

const filterOperators = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains', 'startsWith', 'endsWith' /* add more over time */].includes(value),
);

const columns = [
    { field: 'id', headerName: 'Id', filterOperators },
    { field: 'basic.company', headerName: 'Firma', minWidth: 150, flex: 1, filterOperators },
    { field: 'basic.fullname', headerName: 'Imie Nazwisko', minWidth: 150, flex: 1, filterOperators },
    { field: 'basic.login/email', headerName: 'Login/Email', minWidth: 150, flex: 1, filterOperators },
    { field: 'basic.mobile_phone', headerName: 'Numer telefonu', minWidth: 150, flex: 1, filterOperators },
    { field: 'basic.NIP', headerName: 'NIP', hide: true, filterOperators },
    { field: 'basic.name', headerName: 'Imie', hide: true, filterOperators },
    { field: 'basic.surname', headerName: 'Nazwisko', hide: true, filterOperators },
    { field: 'basic.address', headerName: 'Adres', hide: true, filterOperators },
    { field: 'basic.zip_code', headerName: 'Kod pocztowy', hide: true, filterOperators },
    { field: 'basic.city', headerName: 'Miasto', hide: true, filterOperators },
    { field: 'delivery.company', headerName: 'Firma', hide: true, filterOperators },
    { field: 'delivery.name', headerName: 'Imie', hide: true, filterOperators },
    { field: 'delivery.surname', headerName: 'Nazwisko', hide: true, filterOperators },
    { field: 'delivery.address', headerName: 'Adres', hide: true, filterOperators },
    { field: 'delivery.zip_code', headerName: 'Kod pocztowy', hide: true, filterOperators },
    { field: 'delivery.city', headerName: 'Miasto', hide: true, filterOperators },
]
const columnGroupingModel = [
    {
        groupId: "Dane podstawowe",
        children: [
            { field: 'basic.company' },
            { field: 'basic.fullname' },
            { field: 'basic.login/email' },
            { field: 'basic.mobile_phone' },
            { field: 'basic.NIP' },
            { field: 'basic.name' },
            { field: 'basic.surname' },
            { field: 'basic.address' },
            { field: 'basic.zip_code' },
            { field: 'basic.city' },
        ]
    },
    {
        groupId: "Dane dostawy",
        children: [
            { field: 'delivery.company' },
            { field: 'delivery.name' },
            { field: 'delivery.surname' },
            { field: 'delivery.address' },
            { field: 'delivery.zip_code' },
            { field: 'delivery.city' },
        ]
    }
]

export default function Clients(props) {

    const inputColumns = {
        "Dane podstawowe": [
            { type: TextField, props: { label: "Pełna nazwa firmy", name: "basic.company_fullname" } },
            { type: TextField, props: { label: "Firma", name: "basic.company" } },
            {
                type: AutocompleteText,
                props: {
                    queryPath: '/clients', freeSolo: true, serverOptions: true, label: "NIP", name: "basic.NIP",
                    searchBy: "basic.NIP",
                    optionLabel: ["basic.NIP", "basic.company"],
                    autocomplete: ['basic.company', 'basic.NIP', 'basic.address', 'basic.zip_code', 'basic.city']
                }
            },
            { type: TextField, props: { label: "Adres", name: "basic.address" } },
            { type: TextField, props: { label: "Kod pocztowy", name: "basic.zip_code" } },
            { type: TextField, props: { label: "Miasto", name: "basic.city" } },
            { type: TextField, props: { label: "Imię", name: "basic.name" } },
            { type: TextField, props: { label: "Nazwisko", name: "basic.surname" } },
            { type: TextField, props: { label: "Telefon", name: "basic.mobile_phone" } },
            { type: TextField, props: { label: "Login/Email", name: "basic.login/email" } },
        ],
        "Dane dostawy": [
            { type: TextField, props: { label: "Firma", name: "delivery.company" } },
            { type: TextField, props: { label: "Imię", name: "delivery.name" } },
            { type: TextField, props: { label: "Nazwisko", name: "delivery.surname" } },
            { type: TextField, props: { label: "Adres", name: "delivery.address" } },
            { type: TextField, props: { label: "Kod pocztowy", name: "delivery.zip_code" } },
            { type: TextField, props: { label: "Miasto", name: "delivery.city" } },
        ],
        "Dane płatności": [
            { type: Checkbox, props: { label: "Płatność przelewem", name: "payment.bank_transfer" } },
            { type: TextField, props: { type: "number", label: "Ilość dni przelewu", name: "payment.transfer_days" } },
            { type: TextField, props: { label: "Email", name: "payment.email" } },
            { type: TextField, props: { label: "Hasło", name: "payment.password" } },
        ]
    }
    const copyDataButtonHandle = () => {
        data['delivery.address'] = data['basic.address'];
        data['delivery.city'] = data['basic.city'];
        data['delivery.company'] = data['basic.company'];
        data['delivery.name'] = data['basic.name'];
        data['delivery.surname'] = data['basic.surname'];
        data['delivery.zip_code'] = data['basic.zip_code'];
        setData({ ...data })
    }

    const { lookupId } = useParams();
    const [data, setData] = useState({});

    if (lookupId) return <RowEditPage title={`${(props.disableEdit ? ' Pogląd ' : 'Edycja')} klienta o id: ${lookupId} `}
        queryPath='/clients' lookupId={lookupId} disableInputs={props.disableEdit} dataReference={setData} >
        <Grid xs={12} item className="container" sx={{ marginBottom: "20px", paddingLeft: "4px" }} container>
            <InputRow inputColumns={inputColumns} data={data} disabled={props.disableEdit} container={false} />
            {
                !props.disableEdit && <Button sx={{ marginLeft: "16px", marginBottom: "10px" }} onClick={copyDataButtonHandle} variant="contained">Kopiuj podstawowe do dostawy</Button>
            }
        </Grid>
        {
            props.disableEdit && <Typography variant="h6" textAlign="left" className="container">
                Zamówienia tego klienta:
                <OrdersDataGrid
                    filterData={{
                        field: "client._id",
                        operator: "equals",
                        value: lookupId,
                    }}
                    components={null}
                />
            </Typography>
        }
    </RowEditPage>
    else if (props.add) return <RowAddPage queryPath='/clients' title="Dodawanie klienta">
        <InputRow inputColumns={inputColumns} data={{}} />;
    </RowAddPage>
    else return <DefaultDataGrid
        additionalActionButtons={[
            { icon: AddIcon, iconTooltip: `Dodaj zamowienie dla uzytkownika id: *id*`, linkTo: `/orders/add/*id*`, label: "Dodaj" }
        ]}
        columnGroupingModel={columnGroupingModel}
        columns={columns}
        queryPath='/clients'
    />;
}